export default {
    created: function() {
        if (localStorage.getItem('guestShoppingcart')) {
            this.guestOrderLines = JSON.parse(localStorage.getItem('guestShoppingcart'));
        }
    },
    methods: {
        filterCollection: function(searchItem) {

            let item = this.guestOrderLines.filter(function(value, key, array) {
                if (value.id == searchItem.id) {
                    return value;
                }
            }, searchItem)[0];

            return item;
        },
        removeOrderLine: function(order) {
            return [];
            let key = 0;
            for (let i = 0; i < this.guestOrderLines.length; i++) {
                if (this.guestOrderLines[i] === order) {
                    key = i;
                }
            }

            this.guestOrderLines.splice(key, 1);
        },
        unsetAndPushItem: function(item) {
            let key = 0;
            for (let i = 0; i < this.guestOrderLines.length; i++) {
                if (this.guestOrderLines[i] === item) {
                    key = i;
                }
            }

            this.guestOrderLines.push(this.guestOrderLines.splice(key, 1)[0]);
        },
        changeOrderLine(item) {
            switch (item.order_offer) {
                case 0:
                    let offer = this.filterCollection(item);
                    offer.order_offer = 1;
                    this.unsetAndPushItem(offer);
                    break;
                case 1:
                    let order = this.filterCollection(item);
                    order.order_offer = 0;
                    this.unsetAndPushItem(order);
                    break;
            }
        },
        resetTextboxBorders: function() {
            $("input[name='customerName']").css('border', '');
            $("input[name='customerEmail']").css('border', '');
        },
        submitOrder() {
            let _this = this;
            WinkelwagenEventBus.$emit("disable-radios");
            axios.post('/winkelwagen/afronden', {
                    "refnr": this.refnr,
                    "note": this.note,
                    "customerName": this.customerName,
                    "customerCompany": this.customerCompany,
                    "customerEmail": this.customerEmail,
                    "customerPhone": this.customerPhone,
                    "shoppingCart": localStorage.getItem('guestShoppingcart')
                })
                .then(function(response) {
                    if (response.data.redirect) {
                        localStorage.setItem('guestShoppingcart', JSON.stringify([]));
                        window.location = response.data.redirect;
                    }
                }, _this).catch(function(error) {

                    if (error.response.data.errors.customerName && error.response.data.errors.customerEmail) {
                        _this.$awn.alert("Het naam en email veld zijn verplicht");
                        $("input[name='customerName']").css('border', '1px solid red');
                        $("input[name='customerEmail']").css('border', '1px solid red');
                    } else if (error.response.data.errors.customerName) {
                        $("input[name='customerName']").css('border', '1px solid red');
                        _this.$awn.alert("Het naam veld is verplicht");
                    } else if (error.response.data.errors.customerEmail) {
                        $("input[name='customerEmail']").css('border', '1px solid red');
                        _this.$awn.alert("Het email veld is verplicht");
                    } else {
                        _this.$awn.alert("Oeps, daar ging iets mis, probeert u het later nog eens");
                    }

                    WinkelwagenEventBus.$emit("enable-radios");
                }, _this);
        },
    },
    computed: {
        orderproducts: function() {
            return this.guestOrderLines.filter(function(value, key, collection) {
                if (value.order_offer === 1) {
                    return value;
                }
            })
        },
        offerproducts: function() {
            return this.guestOrderLines.filter(function(value, key, collection) {
                if (value.order_offer === 0) {
                    return value;
                }
            })
        },
        totalPrice: function() {
            let price = 0;

            for (let i = 0; i < this.guestOrderLines.length; i++) {
                if (this.guestOrderLines[i].is_residual_product) {
                    price += parseFloat(this.guestOrderLines[i].price_per_piece) * this.guestOrderLines[i].pieces;
                }
            }

            // if(this.discountPercentage > 0)
            //     price = price * (1 - (this.discountPercentage / 100));

            return price.toFixed(2);
        },
        finishAvailable: function() {
            let order = 0;

            this.guestOrderLines.filter(function(item) {
                if (item.order_offer) {
                    order = 1;
                }
            }, order);

            if (this.refnr != "" &&
                this.customerName != "" &&
                this.customerEmail != "" &&
                this.customerPhone != "" &&
                !order) {
                return this.posting;
            }

            return true
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/cart/helpers/cart/guest.js